(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["catalog-300"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-catalog-category]').forEach((category) => {
    const button = category.querySelector('[data-catalog-load-more]');
    if (!button) return;
    button.addEventListener('click', () => {
      const batchSize = Number(category.dataset.batchSize || 12);
      const hiddenItems = Array.from(category.querySelectorAll('.catalog-300__item--hidden'));
      hiddenItems.slice(0, batchSize).forEach((item) => item.classList.remove('catalog-300__item--hidden'));
      if (category.querySelectorAll('.catalog-300__item--hidden').length === 0) button.hidden = true;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
